export default __webpack_public_path__ + "static/media/fondo_credencial.8cf6dd5b.png";